const angular = require('angular');
const ngMessages = require('angular-messages');
const uiRouter = require('angular-ui-router');
const restangular = require('restangular'); // eslint-disable-line no-unused-vars

const wowCommonModule = require('../common/common.module');
const olyCommonModule = require('../olycommon/olycommon.module');

const addressModuleName = 'wowApp.fulfilment';

const fulfilmentService = require('./fulfilment.service');
const deliveryFeeService = require('./delivery-fee.service');

angular.module(addressModuleName, [olyCommonModule, wowCommonModule, ngMessages, uiRouter, 'restangular'])
    .service('FulfilmentService', fulfilmentService)
    .service('DeliveryFeeService', deliveryFeeService);

// ------------------------------------------
// Components
// ------------------------------------------
require('./address');
require('./delivery');
require('./pickup');
require('./fulfilmentmethod');
require('./timeslots');

module.exports = addressModuleName;



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilment.module.js